const ipConfig = {
    // baseUrl: "http://122.231.43.31:8000" //线上环境
    // baseUrl: "http://122.227.188.14:9292" //线上环境
    // baseUrl: "http://120.26.131.192:80/api" //线上环境
    // baseUrl: "http://192.168.1.89:9000" //线下环境
    baseUrl: "https://nkcebao.com/api" //线上环境
    // baseUrl: "http://120.26.131.192:8080/api" //线上环境
      // baseUrl: "http://192.168.1.89:10200" //线下环境
  
  }
  export default ipConfig 


// WEBPACK FOOTER //
// ./src/utils/ipconfig.js